export const bloomInk = [
  { name: "柔粉", color: "#efa7c1" },
  { name: "奶油白", color: "#fff3df" },
  { name: "香槟金", color: "#e7c27e" },
  { name: "桃杏", color: "#edb49b" },
  { name: "蔷薇", color: "#ce758f" },
  { name: "雾蓝", color: "#9fc6db" },
  { name: "鸢尾紫", color: "#b9a1d2" },
  { name: "鼠尾草绿", color: "#b2c8ac" },
] as const;

export type BloomPaletteSelection = number | "custom";
export type BloomColor = number | string;
export type BloomRgb = readonly [number, number, number];

/** Preserve the numeric preset API while allowing the native picker's sRGB hex value. */
export function resolveBloomColor(value: BloomColor): BloomRgb | null {
  const hex = typeof value === "number" ? bloomInk[value]?.color : value;
  if (!hex || !/^#[\da-f]{6}$/i.test(hex)) return null;
  return [parseInt(hex.slice(1, 3), 16), parseInt(hex.slice(3, 5), 16), parseInt(hex.slice(5, 7), 16)];
}
